import { LocalNext } from '../../domain/form/definition/LocalNext'
import localNextItemFromItem from '../../domain/form/definition/Item'
import { com } from '@eidu/web'
import Item = com.eidu.sharedlib.form.definition.Item

declare global {
  interface Array<T> {
    optionsAfter(this: readonly T[], itemIndex: number): readonly NextOption[]
  }
  interface ReadonlyArray<T> {
    optionsAfter(this: readonly T[], itemIndex: number): readonly NextOption[]
  }
}

Array.prototype.optionsAfter = function (this: readonly Item[], itemIndex: number): readonly NextOption[] {
  return this.slice(itemIndex + 1).flatMap((item) => {
    const nextItem = localNextItemFromItem(item as Item)
    return nextItem ? [nextItem] : []
  })
}

type NextOption = { next: LocalNext; label: string }

export default NextOption
